/* Selet v92 (02/10): JS do carrossel dos cards, antes repetido inline em cada card. */
  (function () {
    if (window.__seletSwipeInit) return;
    window.__seletSwipeInit = true;
    /* v87 (01/10): 2ª+ fotos do carrossel só baixam no 1º toque/arraste/seta (celular) ou ao passar o mouse no card (computador). */
    function seletHyd(sw) {
      if (!sw || sw.__hyd) return; sw.__hyd = true;
      var im = sw.querySelectorAll('img[data-src]');
      for (var k = 0; k < im.length; k++) { var i = im[k]; if (i.dataset.srcset) i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); i.removeAttribute('data-srcset'); }
    }
    function seletHydFrom(e) {
      var t = e.target; if (!t || !t.closest) return;
      var sw = t.closest('.selet-swipe');
      if (!sw) { var c = t.closest('.product-item__inner'); if (c) sw = c.querySelector('.selet-swipe'); }
      if (sw) seletHyd(sw);
    }
    ['touchstart', 'pointerdown', 'mouseover', 'focusin'].forEach(function (ev) { document.addEventListener(ev, seletHydFrom, { capture: true, passive: true }); });
    document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('selet-swipe__track')) seletHyd(t.parentNode); }, true);
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('selet-swipe__track')) return;
      var w = t.clientWidth || 1;
      var i = Math.round(t.scrollLeft / w);
      var dots = t.parentNode.querySelectorAll('.selet-swipe__dot');
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
    }, true);
    ['mousedown','pointerdown','touchstart'].forEach(function (ev) { document.addEventListener(ev, function (e) { var a = e.target.closest && e.target.closest('.selet-swipe__arr'); if (a) { e.stopPropagation(); if (ev !== 'touchstart') e.preventDefault(); } }, true); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.selet-swipe__arr');
      if (!a) return;
      e.preventDefault(); e.stopPropagation();
      var t = a.parentNode.querySelector('.selet-swipe__track');
      var w = t.clientWidth || 1, n = t.children.length, i = Math.round(t.scrollLeft / w);
      i = a.classList.contains('selet-swipe__arr--next') ? (i + 1) % n : (i - 1 + n) % n;
      t.scrollTo({ left: i * w, behavior: 'smooth' });
    }, true);
  })();
